import { WorkstationInfoModel } from "../../interfaces/Login/IWorkstationInfoModel";
import { MissingStockItemMissingReason } from "./../../../utils/Constants";

/**
 * -------------------------------------
 * Action Types definition
 * -------------------------------------
 * */

export const FETCH_SHELVES = "FETCH_SHELVES";
export const SET_FOUND_SHELVES = "SET_FOUND_SHELVES";
export const SET_CURRENT_TOTAL = "SET_CURRENT_TOTAL";
export const SET_VERIFY_OPERATOR = "SET_VERIFY_OPERATOR";
export const REPORT_MISSING_ITEM = "REPORT_MISSING_ITEM";
export const SET_REPORT_MISSING_ITEM = "SET_REPORT_MISSING_ITEM";
export const RESET_STATE = "RESET_STATE";
export const SET_MISSING_SKU_FOUND = "SET_MISSING_SKU_FOUND";
export const SET_MISSING_SKU_FOUND_LOADING = "SET_MISSING_SKU_FOUND_LOADING";
export const SET_STATE = "SET_STATE";
export const FORCE_LIFT_SHELF = "FORCE_LIFT_SHELF";
export const CANCEL_LIFT_SHELF = "CANCEL_LIFT_SHELF";
export const SET_VERIFY_FORCE_LIFT_SHELF = "SET_VERIFY_FORCE_LIFT_SHELF";
export const RESET_VERIFY_FORCE_LIFT_SHELF = "RESET_VERIFY_FORCE_LIFT_SHELF";
export const SET_FORCED_LIFT_SHELVES = "SET_FORCED_LIFT_SHELVES";
export const SET_CURRENT_SHELF = "SET_CURRENT_SHELF";
export const SET_FORCE_LIFT_SHELF_FAILED = "SET_FORCE_LIFT_SHELF_FAILED";
export const SET_SHOW_SKU_AUTOSTORE_REMOVAL_DISABLED = "SET_SHOW_SKU_AUTOSTORE_REMOVAL_DISABLED";
export const SET_AUTOSTORE_SKU_REMOVAL_DISABLED = "SET_AUTOSTORE_SKU_REMOVAL_DISABLED";
export const FETCH_SETTING_AUTOSTORE_SKU_REMOVAL_DISABLED = "FETCH_SETTING_AUTOSTORE_SKU_REMOVAL_DISABLED";
/**
 * -------------------------------------
 * Module specific constants.
 * -------------------------------------
 * */

/**
 * -------------------------------------
 * Action Creator definitions
 * -------------------------------------
 * */

 export const setSkuRemovalAutostoreDisabled = (enabled) => {
  return {
    type: SET_AUTOSTORE_SKU_REMOVAL_DISABLED,
    enabled,
  };
};


 export const setShowMissingSkuRemovalAutostoreDisabled = (showWarning) => {
  return {
    type: SET_SHOW_SKU_AUTOSTORE_REMOVAL_DISABLED,
    showWarning,
  };
};

export const fetchSettingSkuRemovalAutostoreDisabled = () => {
  return {
    type: FETCH_SETTING_AUTOSTORE_SKU_REMOVAL_DISABLED
  };
};


export const setFoundShelves = (foundShelves) => {
  return {
    type: SET_FOUND_SHELVES,
    foundShelves,
  };
};

export const getShelves = (boxItem, branchId) => {
  return {
    type: FETCH_SHELVES,
    boxItem,
    branchId,
  };
};

export const setCurrentTotal = (currentTotal) => {
  return {
    type: SET_CURRENT_TOTAL,
    currentTotal,
  };
};

export const setVerifyOperator = (verifyOperator) => {
  return {
    type: SET_VERIFY_OPERATOR,
    verifyOperator,
  };
};

export const reportMissingItem = (reason, boxItem) => {
  return {
    type: REPORT_MISSING_ITEM,
    payload: { reason, boxItem },
  };
};

export const setMissingSkuFound = (
  shelves,
  boxItem,
  missingAmount,
  fromReview,
  callback,
  successCallback,
  failureCallback,
  operatorId,
  isScanIdValidationRemoveSkuRequired,
  partialDelivery,
  isRxItem
) => {
  return {
    type: SET_MISSING_SKU_FOUND,
    payload: {
      shelves,
      boxItem,
      missingAmount,
      fromReview,
      callback,
      successCallback,
      failureCallback,
      operatorId,
      isScanIdValidationRemoveSkuRequired,
      partialDelivery,
      isRxItem
    },
  };
};

export const resetState = () => {
  return {
    type: RESET_STATE,
  };
};

export const setState = (payload) => {
  return {
    type: SET_STATE,
    payload,
  };
};

export const forceLiftShelf = (shelfNumber, cartID) => {
  return {
    type: FORCE_LIFT_SHELF,
    shelfNumber,
    cartID,
  };
};

export const setForceLiftShelfFailed = () => {
  return {
    type: SET_FORCE_LIFT_SHELF_FAILED,
  };
};

export const cancelLiftShelf = (shelfNumber, cartID) => {
  return {
    type: CANCEL_LIFT_SHELF,
    shelfNumber,
    cartID,
  };
};

export const setForcedLiftShelves = (forcedLiftShelves) => {
  return {
    type: SET_FORCED_LIFT_SHELVES,
    forcedLiftShelves,
  };
};

export const setCurrentShelf = (currentShelf) => {
  return {
    type: SET_CURRENT_SHELF,
    currentShelf,
  };
};

export const setVerifyForceLiftShelf = (currentShelf) => {
  return {
    type: SET_VERIFY_FORCE_LIFT_SHELF,
    currentShelf,
  };
};

export const resetVerifyForceLiftShelf = () => {
  return {
    type: RESET_VERIFY_FORCE_LIFT_SHELF,
  };
};

/**
 * -------------------------------------
 * Reducer definition
 * -------------------------------------
 * */
const initialState = {
  foundShelves: [{}],
  isLoadingShelves: true,
  currentTotal: { total: 0, shelves: [] },
  showRemovalWarning: false,
  amountToRemove: 0,
  verifyOperator: false,
  missingButtonLoading: false,
  missingStockItemID: 0,
  reasonCode: MissingStockItemMissingReason.Unknown,
  missingAmount: 0,
  fromReview: false,
  currentShelf: "",
  forcedLiftShelves: [],
  forceLiftShelfFailed: false,
  forceLiftShelfLoading: false,
  showSkuRemovalAutostoreDisabled: false,
  autostoreSkuRemovalDisabled: false,
};

const missingSkuReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_AUTOSTORE_SKU_REMOVAL_DISABLED:
      return { ...state, autostoreSkuRemovalDisabled: action.enabled };
    case SET_SHOW_SKU_AUTOSTORE_REMOVAL_DISABLED:
      return { ...state, showSkuRemovalAutostoreDisabled: action.showWarning };
    case SET_FOUND_SHELVES:
      return {
        ...state,
        foundShelves: action.foundShelves,
        missingAmount: action.missingAmount,
        isLoadingShelves: false,
      };
    case SET_CURRENT_TOTAL:
      return { ...state, currentTotal: action.currentTotal };
    case SET_VERIFY_OPERATOR:
      return { ...state, verifyOperator: action.verifyOperator };

    case SET_REPORT_MISSING_ITEM:
      return {
        ...state,
        missingStockItemID: action.payload.missingStockItemID,
        reasonCode: action.payload.reasonCode,
      };
    case SET_MISSING_SKU_FOUND_LOADING:
      return { ...state, missingButtonLoading: action.missingButtonLoading };
    case SET_VERIFY_FORCE_LIFT_SHELF:
      return {
        ...state,
        verifyForceLiftShelf: true,
        currentShelf: action.currentShelf,
        forceLiftShelfFailed: false,
        forceLiftShelfLoading: false,
      };
    case RESET_VERIFY_FORCE_LIFT_SHELF:
      return {
        ...state,
        verifyForceLiftShelf: false,
        currentShelf: "",
        forceLiftShelfFailed: false,
        forceLiftShelfLoading: false,
      };
    case FORCE_LIFT_SHELF:
      return {
        ...state,
        forceLiftShelfFailed: false,
        forceLiftShelfLoading: true,
      };
    case SET_FORCED_LIFT_SHELVES:
      return {
        ...state,
        forcedLiftShelves: action.forcedLiftShelves,
        forceLiftShelfFailed: false,
        forceLiftShelfLoading: false,
      };
    case CANCEL_LIFT_SHELF:
      return {
        ...state,
        forceLiftShelfFailed: false,
        forceLiftShelfLoading: false,
      };
    case SET_CURRENT_SHELF:
      return {
        ...state,
        currentShelf: action.currentShelf,
      };
    case SET_FORCE_LIFT_SHELF_FAILED:
      return {
        ...state,
        forceLiftShelfFailed: true,
        forceLiftShelfLoading: false,
      };
    case SET_STATE:
      return { ...state, ...action.payload };
    case RESET_STATE:
      return { ...state, ...initialState, currentTotal: { total: 0, shelves: [] } };
    default:
      return state;
  }
};

/**
 * -------------------------------------
 * Public interface
 * -------------------------------------
 * */
export default missingSkuReducer;
